/**
 * Lightweight placeholder while the below-the-fold chunk loads.
 * Reserves vertical space to reduce CLS when content hydrates.
 */
const BelowFoldSkeleton = () => (
  <div
    className="w-full max-w-6xl mx-auto px-4 py-12 space-y-6"
    aria-busy="true"
    aria-label="Loading rest of page"
  >
    {Array.from({ length: 6 }).map((_, i) => (
      <div
        key={i}
        className="h-28 sm:h-36 rounded-2xl bg-muted/25 animate-pulse"
        style={{ animationDelay: `${i * 80}ms` }}
      />
    ))}
  </div>
);

export default BelowFoldSkeleton;
